import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css']
})
export class ContactUsComponent implements OnInit {
  title = 'WorldERP.com Contact US';

  constructor(private titleService: Title, private metaService: Meta) {}

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    this.metaService.addTags([
      {property: 'og:title', content: 'WorldERP.com Contact US'},
      {property: 'og:type', content: 'contact-us'},
      {property: 'og:url', content: '/contact-us'},
      {property: 'og:image', content: ''}
    ]);
  }

}
